<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐配置</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :new-btn="handleAdd"
      :load-and-request="false"
      :request="fetchData"
    >
      <ex-table-column
        prop="id"
        label="ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="name"
        label="名称"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="dataId"
        label="dataId"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="content"
        label="内容"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="操作"
        align="center"
      >
        <template #default="{row}">
          <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
        </template>
      </ex-table-column>
    </ex-table>

    <el-dialog
      title="推荐配置"
      :visible.sync="show"
      width="50%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="close"
    >
      <el-form :model="form" ref="form" label-width="80px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="dataId" prop="dataId">
          <el-input v-model="form.dataId" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="form.content" type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {addSetting, settingList, updateSetting} from "../../api/configMG";
import {isJsonString} from "../../utils/util";

export default {
  data() {
    return {
      show: false,
      form: {
        name: '',
        content: '',
        dataId: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        dataId: [
          { required: true, message: '请输入dataId', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
  methods: {
    async fetchData(params) {
      let res = await settingList(params)
      return new Promise((c) => {
        c({
          records: res.data.list,
          total: res.data.total
        })
      })
    },
    close() {
      this.show = false
      this.$refs.form.resetFields();
      this.form = {
        name: '',
        content: ''
      }
    },
    handleAdd() {
      this.show = true
    },
    handleEdit(row) {
      this.form = {...row}
      this.show = true
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!isJsonString(this.form.content)) {
            this.$message({
              type: 'error',
              message: '不是正确的JSON数据!'
            });
            return;
          }
          if (this.form.id) {
            updateSetting(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          } else {
            addSetting(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/machine/Recommend.vue